
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 6.98V16c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2L.01 4C.01 2.9.9 2 2 2h10.1c-.06.32-.1.66-.1 1 0 .34.04.68.1 1H2l8 5 3.67-2.29c.47.43 1.02.76 1.63.98L10 11 2 6v10h16V7.9c.74-.15 1.42-.48 2-.92zM14 3c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z","fill":"#000"}})])
          )
        }
      }
    